var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ApiProperty } from "@nestjs/swagger";
import { IsEnum } from "class-validator";
export var ConsentDataResourceScope;
(function (ConsentDataResourceScope) {
    ConsentDataResourceScope["CONTACT_INFO"] = "CONTACT_INFO";
    ConsentDataResourceScope["MEDICATIONS"] = "MEDICATIONS";
    ConsentDataResourceScope["ALLERGIES"] = "ALLERGIES";
    ConsentDataResourceScope["DIAGNOSES"] = "DIAGNOSES";
    ConsentDataResourceScope["LABS"] = "LABS";
    ConsentDataResourceScope["DEMOGRAPHICS"] = "DEMOGRAPHICS";
    ConsentDataResourceScope["CLINICAL_NOTES"] = "CLINICAL_NOTES";
    ConsentDataResourceScope["VISITS"] = "VISITS";
    ConsentDataResourceScope["DIAGNOSTIC_REPORTS"] = "DIAGNOSTIC_REPORTS";
    ConsentDataResourceScope["CLINICAL_VITALS"] = "CLINICAL_VITALS";
    ConsentDataResourceScope["PROCEDURES"] = "PROCEDURES";
    ConsentDataResourceScope["IMMUNIZATIONS"] = "IMMUNIZATIONS";
    ConsentDataResourceScope["IMAGING"] = "IMAGING";
    ConsentDataResourceScope["TREATMENT_PLAN"] = "TREATMENT_PLAN";
    ConsentDataResourceScope["GENOMIC_DATA"] = "GENOMIC_DATA";
    ConsentDataResourceScope["FAMILY_HISTORY"] = "FAMILY_HISTORY";
    ConsentDataResourceScope["SOCIAL_HISTORY"] = "SOCIAL_HISTORY";
    ConsentDataResourceScope["ADMINISTRATIVE_AND_BILLING"] = "ADMINISTRATIVE_AND_BILLING";
})(ConsentDataResourceScope || (ConsentDataResourceScope = {}));
export var ConsentDataSensitivityScope;
(function (ConsentDataSensitivityScope) {
    ConsentDataSensitivityScope["NORMAL"] = "NORMAL";
    ConsentDataSensitivityScope["HIV_OR_STI"] = "HIV_OR_STI";
    ConsentDataSensitivityScope["SUBSTANCE_USE_OR_DRUG_ABUSE"] = "SUBSTANCE_USE_OR_DRUG_ABUSE";
    ConsentDataSensitivityScope["MENTAL_HEALTH"] = "MENTAL_HEALTH";
    ConsentDataSensitivityScope["GENETIC_TESTING"] = "GENETIC_TESTING";
    ConsentDataSensitivityScope["REPRODUCTIVE_HEALTH_DATA"] = "REPRODUCTIVE_HEALTH_DATA";
    ConsentDataSensitivityScope["PSYCHOTHERAPY_NOTES"] = "PSYCHOTHERAPY_NOTES";
    ConsentDataSensitivityScope["SUD_PART_2"] = "SUD_PART_2";
    ConsentDataSensitivityScope["SICKLE_CELL"] = "SICKLE_CELL";
})(ConsentDataSensitivityScope || (ConsentDataSensitivityScope = {}));
export class ConsentDataScope {
}
__decorate([
    ApiProperty({
        enum: ConsentDataResourceScope,
        enumName: "ConsentDataResourceScope",
    }),
    IsEnum(ConsentDataResourceScope)
], ConsentDataScope.prototype, "resourceScope", void 0);
__decorate([
    ApiProperty({
        enum: ConsentDataSensitivityScope,
        enumName: "ConsentDataSensitivityScope",
    }),
    IsEnum(ConsentDataSensitivityScope)
], ConsentDataScope.prototype, "sensitivityScope", void 0);
export function consentDataScopesFromComponentScopes(resourceScopes, sensitivityScopes) {
    return resourceScopes.flatMap((resourceScope) => sensitivityScopes.map((sensitivityScope) => ({ resourceScope, sensitivityScope })));
}
